/**
 * Sky — daytime light ice gradient with subtle horizon band.
 * Cached offscreen, blitted each frame.
 */

export class Sky {
  private cache: HTMLCanvasElement
  private cacheCtx: CanvasRenderingContext2D | null

  constructor() {
    this.cache = document.createElement('canvas')
    this.cacheCtx = this.cache.getContext('2d', { alpha: false })
  }

  resize(w: number, h: number): void {
    this.cache.width = Math.max(1, w)
    this.cache.height = Math.max(1, h)
    const ctx = this.cacheCtx
    if (!ctx) return

    // Base: soft powder blue → almost white → cool tint at bottom
    const g = ctx.createLinearGradient(0, 0, 0, h)
    g.addColorStop(0, '#cde8fa')   // top: powder
    g.addColorStop(0.4, '#e7f5ff') // upper-mid: pale sky
    g.addColorStop(0.7, '#f4fbff') // mid: near-white
    g.addColorStop(1, '#e0efff')   // bottom: cold tint
    ctx.fillStyle = g
    ctx.fillRect(0, 0, w, h)

    // Warm sun bloom top-left
    const sun = ctx.createRadialGradient(w * 0.18, h * 0.05, 0, w * 0.18, h * 0.05, w * 0.55)
    sun.addColorStop(0, 'rgba(255, 240, 210, 0.35)')
    sun.addColorStop(0.4, 'rgba(255, 255, 255, 0.1)')
    sun.addColorStop(1, 'rgba(255, 255, 255, 0)')
    ctx.fillStyle = sun
    ctx.fillRect(0, 0, w, h)

    // Faint cyan horizon accent
    const horizon = ctx.createLinearGradient(0, h * 0.55, 0, h)
    horizon.addColorStop(0, 'rgba(126, 196, 239, 0)')
    horizon.addColorStop(0.7, 'rgba(0, 184, 217, 0.06)')
    horizon.addColorStop(1, 'rgba(0, 85, 168, 0.05)')
    ctx.fillStyle = horizon
    ctx.fillRect(0, h * 0.55, w, h * 0.45)
  }

  draw(ctx: CanvasRenderingContext2D): void {
    ctx.drawImage(this.cache, 0, 0)
  }
}
